import {
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { closeIcon } from "assets/images";
import { DATE_VIEW_FORMAT, TIME_VIEW_FORMAT } from "utils/constants/constant";
import { convertToDateTimeWithFormat } from "utils/helper";
import { ICourseSession } from "utils/interfaces/student-enrolment";

interface IViewSessionsModalProps {
  sessions: Array<ICourseSession>;
  onClose: () => void;
}

const ViewSessionsModal: React.FC<IViewSessionsModalProps> = ({
  sessions,
  onClose,
}) => {
  return (
    <Modal open onClose={onClose}>
      <Box className="common-modal view-sessions-modal">
        <Box className="modal-header">
          <Typography variant="h4">Sessions</Typography>
          <IconButton onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="modal-body view-sessions-modal-body">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ maxWidth: "276px", width: { md: "276px" } }}>
                    Day Number
                  </TableCell>
                  <TableCell sx={{ maxWidth: "495px" }}>Session</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sessions?.map((session, index) => {
                  return (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography>{index + 1}</Typography>
                      </TableCell>
                      <TableCell>
                        {convertToDateTimeWithFormat(
                          session.sessionStartDateTime,
                          DATE_VIEW_FORMAT
                        )}{" "}
                        {convertToDateTimeWithFormat(
                          session.sessionStartDateTime,
                          TIME_VIEW_FORMAT
                        )}
                        {" to "}
                        {convertToDateTimeWithFormat(
                          session.sessionEndDateTime,
                          TIME_VIEW_FORMAT
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Modal>
  );
};
export default ViewSessionsModal;
